// @flow
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Modal from '../../../../../elements/Modal/Modal';
import { FormattedMessage } from 'react-intl';
import classNames from 'classnames/bind';
import Loading from '../../../../../elements/Loading/Loading';

import modalStyle from '../../../../../assets/styles/modal.scss';
import buttonStyle from '../../../../../assets/styles/button.scss';
import style from './VerificationModal.scss';

type Props = {
  +color?: 'orange' | 'lightBlue';
  +getSession: () => void;
  +handleClose?: () => void;
  +showCloseButton?: boolean;
  +modalVisible: boolean;
  +isVerifying?: boolean;
  +isResending?: boolean;
  +resendVerification: () => void;
};


export default class VerificationModal extends Component<Props> {
  static defaultProps = {
    showCloseButton: false,
    color: 'lightBlue',
    isVerifying: false,
    isResending: false,
  };

  render() {
    const { color, getSession, handleClose, showCloseButton, modalVisible,
      isVerifying, isResending, resendVerification } = this.props;
    const _handleClose = handleClose || (() => undefined);
    return (
      <Modal handleClose={() => !isVerifying && !isResending && _handleClose()}
             width={544}
             height={356}
             open={modalVisible}
             showCloseButton={showCloseButton}>
        {(isVerifying || isResending) && <Loading type="sk-three-bounce"
                                                  color={color}
                                                  className={style.modalLoading}
                                                  number={3}/>}
        {!(isVerifying || isResending) &&
        <React.Fragment>
          <FormattedMessage id="verificationModal.title">{
            txt => <h1 className={style.title}>{txt}</h1>
          }</FormattedMessage>
          <FormattedMessage id="verificationModal.content">{
            txt => <p className={classNames(modalStyle.content, style.content)}>{txt}</p>
          }</FormattedMessage>
          <section className={classNames(style.buttonsWrap)}>
            <FormattedMessage id="verificationModal.confirmed">{
              txt => <button className={classNames(buttonStyle.btn, style.btn,
                { [buttonStyle.lightBlue]: color === 'lightBlue' },
                { [buttonStyle.orange]: color === 'orange' })}
                             onClick={getSession}>{txt}</button>
            }</FormattedMessage>
            <FormattedMessage id="verificationModal.resend">{
              txt => <button className={classNames(buttonStyle.btn, buttonStyle.darkGrey, style.btn)}
                             onClick={() => resendVerification()}>{txt}</button>
            }</FormattedMessage>
          </section>
        </React.Fragment>}
      </Modal>
    );
  }
}

VerificationModal.propTypes = {
  color: PropTypes.string,
  getSession: PropTypes.func.isRequired,
  handleClose: PropTypes.func,
  showCloseButton: PropTypes.bool,
  modalVisible: PropTypes.bool.isRequired,
  isVerifying: PropTypes.bool,
  isResending: PropTypes.bool,
  resendVerification: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/modules/auth/auth-modals/verification-modal/component/VerificationModal.jsx